export const createPost = (post) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        
        // make async call to database
        
        const firestore = getFirestore();
        const profile = getState().firebase.profile;
        const authorId = getState().firebase.auth.uid;        
        const emailAddress = getState().firebase.auth.email;        
       
        firestore.collection('posts').add({
            ...post,
            companyName: profile.companyName,
            companyDescription: profile.companyDescription,
            ceoNAME: profile.ceoNAME,
            noOfEmpl: profile.noOfEmpl,
            website: profile.website,
            twitter: profile.twitter,
            linkedin: profile.linkedin,
            facebook: profile.facebook,
            emailAddress: emailAddress,
            authorId: authorId,
            createdAt: new Date()
        })
        .then(() => {
            dispatch({ type: 'CREATE_POST', post })
        })
        .catch((err) => {
            dispatch({ type: 'CREATE_POST_ERROR', err })
        })
    }
};

export const deletePost = (id) => {
    return (dispatch, getState, { getFirebase, getFirestore }) => {
        const firestore = getFirestore();

        firestore.collection('posts').doc(id)
            .delete()
            .then(() => {
                dispatch( {type: 'DELETE_POST', id })
            })
            .catch((err) => {
                dispatch({ type: 'DELETE_POST_ERROR', err })
            })
    }
}